"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SupportingCreativeType {
    constructor({ id, key, name }) {
        this.toJSON = () => ({
            id: this.id,
            key: this.key,
            name: this.name,
        });
        this.id = id;
        this.key = key;
        this.name = name;
    }
}
SupportingCreativeType.fromJSON = (json) => {
    const { id, key, name } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof key !== 'string')
        throw new Error('.key must be a string');
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    switch (key) {
        case 'video':
        case 'static_image':
            // OK
            break;
        default:
            throw new Error(`A creative type key "${key}" is not valid.`);
    }
    return new SupportingCreativeType({
        id,
        key,
        name,
    });
};
exports.default = SupportingCreativeType;
